import styles from "./SWGNews.scss";

import React, { Component } from "react";
import Loader from "./components/Loader/Loader";
import NewsList from "./components/NewsList/NewsList";
import NewsItem from "./components/NewsItem/NewsItem";

class SWGNewsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      newsData: {},
      newsItemData: {}
    };

    this._serviceUrl = "https://infoservice.sunwingtravelgroup.com/Contentful";
    if (this.props.settings.dev) {
      this._serviceUrl =
        "https://infoservicestg.sunwingtravelgroup.com/Contentful";
    }
  }
  componentDidMount() {
    const { settings } = this.props;
    if (settings.mode === "item") {
      this.getNewsData();
    } else {
      this.getNewsData({
        docfrom: 0
      });
    }
  }

  getNewsData = params => {
    const { settings } = this.props;

    // DCIS Query
    let query = {
      lang: [settings.lang],
      spaceid: "pcepxxr6a1mk",
      multivalueconditions: [
        {
          "brandsarr.brands.keyword": settings.brand
        }
      ],
      contenttype: ["newsContainer"]
    };

    // Merge - base query with mode base query
    if (settings.mode === "item") {
      query = Object.assign(query, {
        multivalueconditions: [
          {
            "brandsarr.brands.keyword": settings.brand,
            "slug.keyword": [settings.slug]
          }
        ],
        size: 1
      });
    } else {
      query = Object.assign(query, {
        sort: [
          {
            postDate: { order: "desc" }
          }
        ],
        rangeconditions: [
          {
            postDate: {
              gte: settings.dateStart
            }
          },
          {
            postDate: {
              lte: settings.dateEnd
            }
          }
        ],
        size: settings.itemsPerPage
      });
    }

    // Merge - base + mode query with custom params
    query = Object.assign(query, params);

    fetch(this._serviceUrl, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(query)
    })
      .then(response => response.json())
      .then(data => {
        let modeDataContainer =
          settings.mode === "item" ? "newsItemData" : "newsData";
        this.setState({
          loading: false,
          [modeDataContainer]: data
        });
      });
  };

  render() {
    // Destructure all props to get widget settings (future settings will be available automatically for NewsList)
    const { customClassName = "", mode, ...settings } = this.props.settings;

    return (
      <section
        className={`swg-news-container ${customClassName} ${styles.main}`}
      >
        {this.state.loading ? (
          <Loader />
        ) : mode === "item" ? (
          <NewsItem
            data={this.state.newsItemData}
            settings={settings}
            getNewsData={this.getNewsData}
            widgetId={this.props.widgetId}
          />
        ) : (
          <NewsList
            data={this.state.newsData}
            settings={settings}
            getNewsData={this.getNewsData}
            widgetId={this.props.widgetId}
            widgetInstance={this.props.widgetInstance}
          />
        )}
      </section>
    );
  }
}

export default SWGNewsList;
